import React from 'react';
import {Button, Col, Container, Row} from 'reactstrap';
import {usePhaseState} from 'funnel-schedule/phase-context';
import ClosedCaptionModal from 'components/Broadcasts/ClosedCaptionModal';
import {Link, animateScroll as scroll} from 'react-scroll';
import CheckoutButton from 'components/CheckoutButton';

export default function VideoButtons(props) {
  const {
    phases: {
      default: defaultSchedule = {
        phase: 'before',
        currentActionHour: 0,
        actionHours: [
          {
            date: '',
            description: '',
            speaker: [{name: '', shortName: '', bio: '', image: '', url: ''}],
            title: '',
            video: '',
            thumb: '',
            recipe: ''
          }
        ],
        noBroadcastSales: false,
        broadcastMonthOverride: ''
      },
      sales: salesSchedule = {
        phase: 'before',
        salesEndDate: '',
        salesCtaCopy: ''
      }
    }
  } = usePhaseState();

  const isSeries = defaultSchedule.actionHours.length > 1;
  const isDollarTrial = salesSchedule.offerFlag === 'dollarTrial';

  return (
    <div className="video-buttons text-center d-flex align-items-center justify-content-center">
      {props.noSalesBtn || !isSeries ? null : (
        <div className="mr-2">
          <Link
            className="btn btn-orange text-white px-4"
            activeClass="active"
            spy={true}
            offset={0}
            to="cta-3"
            smooth={true}
            href="#"
          >
            Join WHOLE Life Club
          </Link>
        </div>
      )}
      <div className="mr-2">
        <Link
          className="btn btn-medium-gray text-white px-4"
          activeClass="active"
          spy={true}
          offset={0}
          to="comments"
          smooth={true}
          href="#"
        >
          Comment Now
        </Link>
      </div>
      <ClosedCaptionModal />
    </div>
  );
}
